<template>
  <main v-if="product" class="col-md-9 ms-sm-auto col-lg-10 px-md-4">
    <form method="post" id="form-post-product" @submit.prevent="onSubmit">

      <div class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
        <h1 class="h2">Product {{product.title}}</h1>
        <div>

          <button :class="{clicked: btnClicked}" class="btn btn-primary save-btn rounded font-sm hover-up" type="submit">
            <span class="save-product"><i class="check fs-sm me-1"></i>Opslaan</span>
            <span class="saved">Opgeslagen</span> <i class="ci-arrow-down-circle"></i>
          </button>
        </div>
      </div>
      <div class="card">
        <div class="card-body">
          <h5 class="card-title">Algemeen</h5>

            <div class="mb-3">
              <label class="form-label" for="product-title">Product titel<span class="text-danger">*</span></label>
              <input class="form-control" type="text" required id="product-title" v-model="product.title">

            </div>
            <div class="mb-3">
              <div class="col-lg-4">
              <label class="form-label" for="product-category">Categorie<span class="text-danger">*</span></label>
                <select v-model="product.category_id" class="form-select" id="product-category" required>
                  <option value="">Kies een categorie...</option>
                  <option v-for="category in categories" :key="category.id" :value="category.id">{{category.longDescription}}</option>

                </select>
              </div>
            </div>

            <div class="mb-3 ">
              <label class="form-label" for="product-sales-price">Beschikbaar</label>
              <div class="form-check form-switch align-middle">
                <input type="checkbox" class="form-check-input" id="publishedSwitch" v-model="product.published">
                <label class="form-check-label" for="publishedSwitch">Artikel is beschikbaar in de shop</label>
              </div>
            </div>


            <div class="mb-3">
              <label class="form-label">Product info<span class="text-danger">*</span></label>

              <editor
                  api-key="flrjy63babnnz8dnnflouas7aac5opq3j0lr85ym69yzpij1"
                  v-model="product.info"
                  :init="{
                    height: 300,
                    menubar: false,
                  }"

              />
            </div>
            <div class="row">
              <div class="col-lg-4">
                <div class="mb-3">
                  <label class="form-label" for="product-price">Prijs {{product.saleItem?'per stuk':'per dag'}}<span class="text-danger">*</span></label>
                  <input class="form-control" type="text" required id="product-price" v-model="product.price">

                </div>
              </div>

              <div class="col-lg-4 ">
                <div class="mb-3 ">
                  <label class="form-label" for="product-sales-price">Sales</label>
                  <div class="form-check form-switch align-middle">
                    <input type="checkbox" class="form-check-input" id="customSwitch1" v-model="product.sale">
                    <label class="form-check-label" for="customSwitch1">Artikel is in de uitverkoop?</label>
                  </div>
                </div>
              </div>
              <div class="col-lg-4">
                <div class="mb-3">
                  <label class="form-label" for="product-sales-price">Saleprijs {{product.saleItem?'per stuk':'per dag'}}</label>
                  <input class="form-control" type="text" id="product-sales-price" v-model="product.sales_price">

                </div>
              </div>
            </div>
          <div class="col-lg-4 ">
            <div class="mb-3 ">
              <label class="form-label">Verkoopartikel</label>
              <div class="form-check form-switch align-middle">
                <input type="checkbox" class="form-check-input" id="saleItemSwitch" v-model="product.saleItem">
                <label class="form-check-label" for="saleItemSwitch">Dit artikel kan gekocht worden</label>
              </div>
            </div>
          </div>

        </div>
      </div>
      <div class="card">
        <div class="card-body">
          <h5 class="card-title">Media</h5>

          <div class="row gallery">

            <!-- Item -->
            <div v-for="image in images" :key="image.id" class="col-lg-4 col-md-6 col-sm-10 offset-md-0 offset-sm-1 px-0 ">
              <div class="image">
                <img :src="image.image + '?width=225&height=150'" alt="Product" class="img-thumbnail rounded mx-auto d-block">
                <div class="overlay text-center">
                    <span @click="removeImage(image.id)" class="ci-close" style="cursor:pointer" title="Verwijderen"></span>
                </div>
              </div>
            </div>
            <div v-if="images.length < 6" class="col-lg-4 col-md-6 col-sm-10 offset-md-0 offset-sm-1 px-0 ">
              <div class="image">
                <img src="data:image/png;base64, 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" alt="Product" class="img-thumbnail rounded mx-auto d-block">
                <div class="overlay text-center">
                  <input type="file" @change="addImage( $event )" accept="image/*" ref="file" style="display: none">
                  <span @click="$refs.file.click()" class="ci-add" style="cursor:pointer" title="Toevoegen"></span>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
      <div class="card">
        <div class="card-body">
          <h5 class="card-title">Product tekst</h5>
          <div class="mb-3">
            <editor
                api-key="flrjy63babnnz8dnnflouas7aac5opq3j0lr85ym69yzpij1"
                v-model="product.description"
                :init="{
                    height: 500,
                    menubar: false,
                  }"
            />
          </div>

        </div>
      </div>
    </form>
  </main>
</template>

<script>

import Editor from '@tinymce/tinymce-vue'


export default {
  name: "AdminProducts",
  components: {
    'editor': Editor
  },
  props: ['prodId'],
  data() {
    return {
      btnClicked: false,
      images: []
    }
  },
  methods: {
    validateForm() {
      if (this.productTitle === '') {
        return false;
      }
      if (this.productCategory === '') {
        return false;
      }
      return true;
    },
    onSubmit() {
      if (this.validateForm()) {
        this.$store.dispatch('prods/updateProduct', {product: this.product, images: this.images});
        this.btnClicked = true;
        setTimeout(() => {
          this.btnClicked = false;
          this.$router.replace('/admin/products')
        }, 2000);
      }
    },
    removeImage(id) {
      this.images = this.product.images.filter((image) => {
        return image.id !== id
      });
    },
    addImage(e) {
      this.$store.dispatch('prods/addImage', {prodId: this.product.id, filename: e.target.files[0]});
    }
  },
  computed: {
    product() {
      return this.$store.getters['prods/product'];
    },
    categories() {
      let cats = this.$store.getters['prods/flatCategories'];
      return cats.sort((a,b) => a.longDescription > b.longDescription?1:((b.longDescription > a.longDescription) ? -1 : 0));
    }
  },
  watch: {
    product(value) {
      this.images = value.images;
    },
  },
  created() {
    if (this.prodId !== 'new') {
      this.$store.dispatch('prods/loadProduct', this.prodId);
    }
    this.$store.dispatch('prods/loadFlatCategories',{});


  }

}
</script>

<style scoped>
.card {
  margin-bottom: 20px;
}

.save-btn {
  position: relative;
  outline: 0;
  color: #fff;
  border: none;
  height: 48px;
  width: 200px;
  padding: 10px;
  border-radius: 10px;
  line-height: 0;
  overflow: hidden
}

.save-btn:focus {
  outline: none !important
}

.save-btn .ci-arrow-down-circle {
  position: absolute;
  z-index: 1;
  top: 50%;
  left: -20%;
  font-size: 1.5em;
  transform: translate(-50%, -50%)
}

.save-btn span {
  position: absolute;
  left: 50%;
  top: 50%;
  color: #fff;
  transform: translate(-50%, -50%);
  font-size: 16px
}

.save-btn span.saved {
  opacity: 0
}


.save-btn.clicked .fa-plus {
  animation: addicon 1s ease-in forwards
}

.save-btn.clicked {
  animation: color 1s ease-in forwards
}

.save-btn.clicked .ci-arrow-down-circle {
  animation: circle 0.5s ease-in forwards
}

.save-btn.clicked span.save-product {
  animation: saveProduct 1s ease-in forwards
}

.save-btn.clicked span.saved {
  animation: saved 1s ease-in forwards
}


@keyframes addicon {
  0% {
    opacity: 1
  }

  30%,
  100% {
    opacity: 0
  }
}

@keyframes circle {
  0% {
    left: -10%
  }

  100% {
    left: 20%
  }
}

@keyframes check {

  0%,
  40% {
    top: -20%
  }

  60% {
    top: 48%
  }

  100% {
    top: 48%
  }
}

@keyframes saveProduct {

  0%,
  30% {
    opacity: 1
  }

  30%,
  100% {
    opacity: 0
  }
}

@keyframes saved {

  0%,
  80% {
    opacity: 0
  }

  100% {
    opacity: 1
  }
}

@keyframes color {
  0% {
    background-color: #FE3638
  }

  80%,
  100% {
    background-color: green
  }
}

.image {
  position: relative;
  width: 100%;
  overflow: hidden
}

.image .overlay {
  position: absolute;
  bottom: 0;
  padding-left: 25px;
  padding-top: 15px;
  width: 100%;
  height: 70%;
  color: white;
  font-size: 20px;
  z-index: 5;
  opacity: 0;
}

.image .overlay::before {
  content: "";
  background: #ffff;
  height: 100%;
  width: 100%;
  z-index: 1;
  position: absolute;
  left: 0;
  bottom: -150px;
  z-index: -2;
  opacity: 0.5;
  transition: all 0.3s ease-out
}

.image:hover .overlay {
  color: black;
  opacity: 10;
}

.container .image:hover .overlay .amount,
.container .image:hover .overlay .h4,
.container .image:hover .overlay .textmuted,
.container .image:hover .overlay .fa-star,
.container .image:hover .overlay .fa-star-half-alt,
.container .image:hover .overlay .review {
  color: black
}

.image:hover .overlay::before {
  bottom: 0px
}

/*div.gallery div:hover {*/
/*  border: 1px dotted #C0C0C0;*/
/*}*/
</style>